var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckBlank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    fill: "white",
    stroke: "#6FB24B",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3973 13.6935L8.66229 11.7932C8.56887 11.6907 8.44204 11.6331 8.30979 11.6331C8.17753 11.6331 8.0507 11.6907 7.95729 11.7932C7.76229 12.0068 7.76229 12.3518 7.95729 12.5654L10.0473 14.8544C10.2423 15.068 10.5573 15.068 10.7523 14.8544L16.0423 9.06061C16.2373 8.84704 16.2373 8.50204 16.0423 8.28847C15.9489 8.18592 15.822 8.1283 15.6898 8.1283C15.5575 8.1283 15.4307 8.18592 15.3373 8.28847L10.3973 13.6935Z",
    fill: "#6FB24B",
    stroke: "#6FB24B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBlank);
export default __webpack_public_path__ + "static/media/check-blank.b28cfd08.svg";
export { ForwardRef as ReactComponent };